"use strict";

exports.__esModule = true;
exports.ElementEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ElementEditorController = require("./ElementEditorController");
var _ElementEditorContext = require("./ElementEditorContext");
var _ElementEditorBaseLayer = require("./ElementEditorBaseLayer");
var _ElementEditorSidebar = require("./ElementEditorSidebar");
var _ElementEditorHorizontalToolbar = require("./ElementEditorHorizontalToolbar");
var _ElementEditorVerticalToolbar = require("./ElementEditorVerticalToolbar");
var _common = require("../common");
var _Core = require("../../Core");
var _ElementEditorSaveTemplateDialog = require("./ElementEditorSaveTemplateDialog");
var _LayoutTemplate = require("../../LayoutTemplate");
var _ElementEditorChooseTemplateDialog = require("./ElementEditorChooseTemplateDialog");
var _Theme = require("../../Theme");
var _userActionsContext = require("../../UserActions/userActionsContext");
var _class;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ElementEditorContainer = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditor__ElementEditorContainer",
  componentId: "sc-1cvgjjf-0"
})(["display:grid;grid-template-columns:225px 1fr fit-content(25%);grid-template-rows:42px calc( 100vh - ", " - ", " );grid-template-areas:\"palette toolbar toolbar\" \"palette content sidebar\";max-height:calc(100vh - ", " - ", ");"], (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("ToolbarHeight"), (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("ToolbarHeight"));
var ElementEditorContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditor__ElementEditorContentContainer",
  componentId: "sc-1cvgjjf-1"
})(["grid-area:content;overflow:auto;max-height:100%;max-width:100%;"]);
var ElementEditor = exports.ElementEditor = (0, _userActionsContext.withUserActionsContext)(_class = /*#__PURE__*/function (_Component) {
  function ElementEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      searchQuery: ""
    };
    _this.renderDraggedElement = function (_ref) {
      var type = _ref.type;
      var widgets = _this.props.widgets;
      var widget = (0, _common.getWidget)(widgets, type);
      if (!widget) {
        return type;
      }
      return widget.label;
    };
    return _this;
  }
  _inheritsLoose(ElementEditor, _Component);
  var _proto = ElementEditor.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      onChange = _this$props.onChange,
      rootElement = _this$props.rootElement,
      widgets = _this$props.widgets,
      userActions = _this$props.userActions;
    return /*#__PURE__*/_react["default"].createElement(_LayoutTemplate.LayoutTemplateCollection, null, function (collection) {
      return /*#__PURE__*/_react["default"].createElement(_LayoutTemplate.LayoutTemplateCollectionContext.Provider, {
        value: collection
      }, /*#__PURE__*/_react["default"].createElement(_ElementEditorController.ElementEditorController, {
        onChange: onChange,
        rootElement: rootElement,
        widgets: widgets,
        userActions: userActions
      }, function (elementEditor) {
        return /*#__PURE__*/_react["default"].createElement(_ElementEditorContext.ElementEditorContext.Provider, {
          value: elementEditor
        }, /*#__PURE__*/_react["default"].createElement(ElementEditorContainer, {
          "data-testid": "ElementEditor"
        }, /*#__PURE__*/_react["default"].createElement(_ElementEditorVerticalToolbar.ElementEditorVerticalToolbar, {
          elementEditor: elementEditor,
          searchQuery: _this2.state.searchQuery,
          onSearch: function onSearch(searchQuery) {
            return _this2.setState({
              searchQuery: searchQuery
            });
          }
        }), /*#__PURE__*/_react["default"].createElement(_ElementEditorHorizontalToolbar.ElementEditorHorizontalToolbar, {
          elementEditor: elementEditor
        }), /*#__PURE__*/_react["default"].createElement(ElementEditorContentContainer, null, /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, function (_ref2) {
          var width = _ref2.width,
            height = _ref2.height;
          return /*#__PURE__*/_react["default"].createElement(_ElementEditorBaseLayer.ElementEditorBaseLayer, {
            elementEditor: elementEditor,
            width: width,
            height: height
          });
        })), /*#__PURE__*/_react["default"].createElement(_ElementEditorSidebar.ElementEditorSidebar, {
          elementEditor: elementEditor
        }), /*#__PURE__*/_react["default"].createElement(_ElementEditorSaveTemplateDialog.ElementEditorSaveTemplateDialog, {
          elementEditor: elementEditor
        }), /*#__PURE__*/_react["default"].createElement(_ElementEditorChooseTemplateDialog.ElementEditorChooseTemplateDialog, {
          elementEditor: elementEditor
        })));
      }));
    });
  };
  return ElementEditor;
}(_react.Component)) || _class;